module.exports = __webpack_public_path__ + "img/timber_cove.9bc2e444.svg";